module.exports = __webpack_public_path__ + "static/img/0000智慧食堂打印程序.42df236.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000智慧食堂打印程序.jpg
// module id = AIMJ
// module chunks = 0